// Shared passive backdrop layer for game overlays.

import React from 'react';
import { motion } from 'framer-motion';

const GameBackdrop: React.FC = () => (
  <motion.div
    className="pointer-events-none fixed inset-0 isolate z-[200] bg-neutral-950/65"
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.4, ease: 'easeOut' }}
  />
);

export default GameBackdrop;
